import type {
  SchoolAdminAffiliationFailureResponse,
  SchoolAdminAffiliationSuccessResponse,
  TeacherSchoolAffiliationFailureResponse,
  TeacherSchoolAffiliationSuccessResponse,
} from "./mutations.type";

export const teacherSchoolAffiliationSuccessResponseMock: TeacherSchoolAffiliationSuccessResponse =
  {
    user_id: "85d4430a31dc425cada976396e154ca8",
    schools: [
      {
        unique_id: "5a43462be7be4b94943187be22ee6870",
        name: "Sample Elementary School",
      },
    ],
  };

export const teacherSchoolAffiliationFailureResponseMock: TeacherSchoolAffiliationFailureResponse =
  {
    non_field_errors: ["District selected does not allow new accounts."],
  };

export const schoolAdminSchoolAffiliationSuccessResponseMock: SchoolAdminAffiliationSuccessResponse =
  {
    user_id: "85d4430a31dc425cada976396e154ca8",
    schools: [
      {
        unique_id: "5a43462be7be4b94943187be22ee6870",
        name: "Sample Elementary School",
      },
    ],
  };

export const schoolAdminSchoolAffiliationFailureResponseMock: SchoolAdminAffiliationFailureResponse =
  {
    non_field_errors: ["District(s) selected do not allow new accounts."],
  };

export const genericErrorMessage:
  | SchoolAdminAffiliationFailureResponse
  | TeacherSchoolAffiliationFailureResponse = {
  detail: "Failed to fetch",
};
